module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 1e-05","quantity":0},{"color":"#9dc4b5","label":" 1e-05- 0.16868","quantity":0.00169},{"color":"#e6efc3","label":" 0.16868- 0.49488","quantity":0.00495},{"color":"#ffe89e","label":" 0.49488- 1.0318","quantity":0.01032},{"color":"#f5af7f","label":" 1.0318- 1.9307","quantity":0.01931},{"color":"#ed6d32","label":" 1.9307- 12.47876","quantity":0.12479}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/cfxssl_raster/wheat_MME_1981_2016_lcr_70.json
// module id = CgaN
// module chunks = 171